import React, { useState, useEffect } from 'react';
import "../styleFiles/Navbar.css";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [windowSize, setWindowSize] = useState(window.innerWidth > 980 ? "nav-links-show" : "nav-links-small");
  const [linksVisibility, setLinksVisibility] = useState(window.innerWidth > 980 ? "" : "d-none");
  const [titleVisibility, setTitleVisibility] = useState("");
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 980) {
        setWindowSize("nav-links-small");
        setLinksVisibility("d-none");
        setTitleVisibility("");
      } else {
        setWindowSize("nav-links-show");
        setLinksVisibility("");
        setTitleVisibility("");
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const ToggleList = () => {
        if (window.innerWidth < 980) {
            setWindowSize(prev => prev === 'nav-links-show' ? 'nav-links-small' : 'nav-links-show');
            setTitleVisibility(prev => prev === 'd-none' ? '' : 'd-none');
        }
  };

  const navLinks = [
    { path: "/", label: "About" },
    { path: "/skills", label: "Skills" },
    { path: "/projects", label: "Projects" },
    { path: "/education", label: "Education" },
    { path: "/experience", label: "Experience" },
    { path: "/certificates", label: "Certificates" },
    { path: "/contactus", label: "Contact Us" }
  ];

  return (
    <nav className={titleVisibility ? "justify-content-center" : ""}>
      <div className='menu-title'>
        <h2 className={titleVisibility}> <span>Ahmed</span> Osama </h2>
      </div>
      <div className="menu-wrapper">
        <i
          className={linksVisibility ? "fa-solid fa-bars fa-2x" : "fa-solid fa-bars d-none"}
          onClick={ToggleList}
        ></i>
        <ul className={windowSize}>
          {navLinks.map((link, idx) => (
            <li
                key={idx}
                onClick={ToggleList}
                className={location.pathname === link.path ? 'active' : ''}
                >
                <Link to={link.path}>{link.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
